export var NODE_TYPE_QUERY = 'query';
export var NODE_TYPE_CLAUSE = 'clause';
export var NODE_TYPE_OPERAND = 'operand';
export var NODE_TYPE_ORDER_BY = 'order_by';